import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Products } from '@grandvisionhq/api-client';
import { useApiConfig, useIntl } from '@grandvisionhq/state';
import { parseCTUpsellData } from '../../../utils/parse-ct-upsell-data.js';
import { UpsellItemContainer } from './UpsellItemContainer.js';

const UpsellCategoryContainer = ({ categoryKey  })=>{
    const { productsUrl  } = useApiConfig();
    const { getLabel , locale  } = useIntl();
    const [upsellProducts, setUpsellProducts] = React.useState([]);
    const cancelled = React.useRef(false);
    /**
   * Fetch and parse upsell products for a given category key.
   */ React.useEffect(()=>{
        const fetchUpsellProducts = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                try {
                    const { results  } = yield Products.query(productsUrl, {
                        categoryType: categoryKey
                    });
                    if (cancelled.current) {
                        return;
                    }
                    const parsedProducts = parseCTUpsellData(results, locale, getLabel);
                    setUpsellProducts(parsedProducts);
                } catch (e) {
                    console.error(`Error fetching upsell products ${e.message}`);
                }
            });
            return function fetchUpsellProducts() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchUpsellProducts();
        return ()=>{
            cancelled.current = true;
        };
    // We do not wish to re-fetch the upsell products when the cancelled value changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        productsUrl,
        categoryKey,
        setUpsellProducts
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, upsellProducts.map((product)=>/*#__PURE__*/ React.createElement(UpsellItemContainer, swcHelpers.extends({
            key: product.sku
        }, product))
    ));
};

export { UpsellCategoryContainer };
//# sourceMappingURL=UpsellCategoryContainer.js.map
